import React, { useEffect, useState, forwardRef, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { getDriveFileUrl } from '../../utils'
import "bootstrap/dist/css/bootstrap.min.css";
import "./FilesViewModal.css";
import { BiArrowBack } from "react-icons/bi";
import { FiDownload } from "react-icons/fi";
import { BiPrinter } from "react-icons/bi";
import FileFormat from "./FileFormat";
import { useImmer } from "use-immer";
import { saveAs } from "file-saver";
import { ToastContainer, toast } from "react-toastify";
// import withReactContent from "sweetalert2-react-content";
import "react-toastify/dist/ReactToastify.css";

const toastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
// 20MB
const SIZE_LIMIT_PRINT = 20971520;
// import $ from 'jquery';

function FilesViewModal({ open, onClose }, ref) {
  useEffect(() => {
    if (open) {
      // hide chatBox widget
      window.Tawk_API.hideWidget();
      window.$("#iframemodal").on("load", () => {
        const head = window.$("#iframemodal").contents();
        console.log(head.html());
        let css = `
        <style type="text/css">
        // ajju 
        div.ndfHFb-c4YZDc-bnBfGc.ndfHFb-c4YZDc-zTETae, div[role='main'],body {
          background: black;
          width:50px;
          opacity: 0.8;
        }
        body {
          background: red !important;
        }
        div[data-tooltip='Pop-out'] {
          display: none !important;
        }
        </style>`;
        window.$(head).append(css);
        // $(head).css('background', 'black').css("opacity", "0.8");
      })
    }
    return () => {
      setGeneratedLinks({ download: null, print: null });
      window.Tawk_API.showWidget();
    }
  }, [open])

  const file = ref.current;
  console.log(file);
  const { print, download, preview } = getDriveFileUrl(file.mimeType, file.fileId);
  const [generatedLinks, setGeneratedLinks] = useImmer({ download: null, print: null });
  const handleLinkGenerate = async (LINK_TYPE) => {
    let url, fileName;
    if (LINK_TYPE === "DOWNLOAD") {
      url = download;
      fileName = file.name;
    }
    else {
      url = print;
      fileName = file.name + ".pdf";
    }
    const loadingToast = toast.loading("Link generating...", {
      autoClose: true,
      closeOnClick: false,
      toastId: "linkRef",
      closeButton: false
    });
    const res = await (await fetch("/api/file/downloadable", {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify({
        url: url
      })
    })).json();
    if (res.status !== "failed") {
      setGeneratedLinks(draft => {
        if (LINK_TYPE === "DOWNLOAD") {
          draft.download = res.url;
        }
        else {
          draft.print = res.url;
        }
      });
      toast.update(loadingToast, { render: "Link is ready", type: "success", isLoading: false, toastId: "linkRef", autoClose: true, closeOnClick: true, icon: true });
      saveAs(res.url, fileName);
    }
    else {
      toast.update(loadingToast, { render: "Link not available", type: "error", isLoading: false, icon: true });
    }
  }

  return (
    <div ref={ref}>
      <ToastContainer containerId="linkRef" />
      <Modal
        show={open}
        className="modalmain"
        onHide={() => onClose()}
        fullscreen={true}
        backdrop={'static'}
      >
        <Modal.Header className="modalheader transBlack">
          <Modal.Title className="modaltitle">
            <div>
              <BiArrowBack onClick={() => onClose()} style={{ marginRight: "10px", cursor: "pointer" }} />
              <FileFormat {...file} />
              {file.name}
            </div>
            <div>
              {(print && (parseInt(file.size || 0) <= SIZE_LIMIT_PRINT)) ? <>
                {
                  generatedLinks.print ? <a href={generatedLinks.print} style={{ color: "white" }}><BiPrinter /></a> :
                    <BiPrinter onClick={(e) => handleLinkGenerate("PRINT")} />
                }</> : <></>}
              {
                generatedLinks.download ? <a href={generatedLinks.download} style={{ color: "white" }}><FiDownload style={{ marginLeft: "10px" }} /></a> :
                  <FiDownload style={{ marginLeft: "10px" }} onClick={(e) => handleLinkGenerate("DOWNLOAD")} />
              }
              {/* <a href={download} style={{ color: "white" }}><FiDownload style={{ marginLeft: "10px" }} /></a> */}
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBody" onClick={() => onClose()}>
          <div className="col-md-2 transBlack"></div>
          <iframe
            src={preview}
            frameborder="0"
            allowfullscreen="true"
            mozallowfullscreen="true"
            webkitallowfullscreen="true"
            className="col-12 col-md-8"
            id="iframemodal"
            title="insidemodal"
          ></iframe>
          <div className="coverDriveOpen" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}></div>
          <div className="col-md-2 transBlack"></div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
export default forwardRef(FilesViewModal);
